import { IconCrate } from './icons';

export function Brandmark({ subtitle }: { subtitle?: string }) {
  return (
    <div className="brandmark">
      <IconCrate />
      <div className="btext">
        <span className="bname">CaissePilot</span>
        {subtitle && <span className="bsub">{subtitle}</span>}
      </div>
    </div>
  );
}
